export const header = {
  wrapper: {
    style: {
      display: "flex",
      aligItems: "center",
      borderRadius: "8px",
    },
  },

  section: {
    vertical: true,
    wrap: "wrap",
    justify: "space-between",
    gap: "middle",
  },

  headline: {
    level: 5,
  },

  tagSection: {
    align: "center",
    gap: "middle",
  },

  tag: {
    color: "success",
  },
};

export const actionsStruct = {
  actionSection: {
    gap: "8px",
    justify: "flex-end",
    wrap: "wrap"
  },

  actionButtonNext: {
    type: "primary"
  },

  actionButtonPrev: {
      type: "primary",
      ghost: true
  },
};